import { Table, TableProps } from 'antd';
import { SorterResult } from 'antd/lib/table/interface';
import { DvmExamListSort, DvmExamOutput, Order } from 'gql/types';
import { useSort } from 'modules/common/hooks';
import { usePagination } from 'modules/navigation/hooks/usePagination';
import { FC } from 'react';

import { getColumns } from './columns';

const useDvmExamListSort = () => useSort<DvmExamListSort>();

type Props = {
  dvmExams: DvmExamOutput[];
  updateDvmExamHandler: (data: DvmExamOutput) => void;
  removeDvmExamHandler: (id: string) => void;
  pagination: ReturnType<typeof usePagination>;
  sort: ReturnType<typeof useDvmExamListSort>;
};

export const DvmExamTable: FC<Props> = ({
  dvmExams,
  pagination,
  sort,
  removeDvmExamHandler,
  updateDvmExamHandler,
}) => {
  const columns = getColumns({
    updateDvmExamHandler,
    removeDvmExamHandler,
  });

  const onTableChange: TableProps<DvmExamOutput>['onChange'] = (
    _,
    __,
    sorter,
    extra
  ) => {
    if (extra.action === 'sort') {
      const tableSorter = sorter as SorterResult<DvmExamOutput>;
      const fieldName = tableSorter.columnKey as DvmExamListSort;
      const order = tableSorter.order === 'ascend' ? Order.Asc : Order.Desc;
      if (fieldName && order && tableSorter.order) {
        sort.setSortOption({ fieldName, order });
      }
      if (!(sorter as any).order) {
        sort.removeSortOption(fieldName);
      }
    }
  };

  return (
    <Table
      rowKey={({ id }) => id}
      columns={columns}
      dataSource={dvmExams}
      onChange={onTableChange}
      pagination={pagination.config}
      scroll={{ x: 750 }}
    />
  );
};
